module.exports = __webpack_public_path__ + "media/images/estate_owners/ico_01-a9b8b6ce57e20ba83458c62de4ca1cf6.png";